export default "__VITE_ASSET__ikq0V8az__"